export const MERGE_CERTIFICATION_TEST_RESULT = "MERGE_CERTIFICATION_TEST_RESULT";
export const CLEAN_CERTIFICATION_TEST_RESULT = "CLEAN_CERTIFICATION_TEST_RESULT";
